import styled from 'styled-components';

export const RoundBox = styled.div`
  background: #f5f6ff;
  position: absolute;
  border-radius: 100px;
`;
